import axios from 'axios';

const api = axios.create({
  //baseURL: 'http://localhost:5001', // or your deployed backend URL
  baseURL: 'https://server.slotify.ir',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token automatically if you use JWT later
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
